import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { CloseIcon } from '@chakra-ui/icons';
import { Box, Spacer, useMediaQuery, useDisclosure } from '@chakra-ui/react';
import CenteredWrapper from 'ui/CenteredWrapper';
import theme from 'ui/theme/theme';
import ConfirmCloseModal from './ConfirmCloseModel';
import { DynivyLogo } from 'components/Logo';

import {
  Header,
  LogoLink,
  CloseLink,
  StyledFlex,
  Container,
  BreadcrumbContainer,
} from './WritingFormHeader.styles';
import ProgressBreadcrumb from './ProgressBreadcrumb';

function WritingFormHeader({
  hasBreadcrumb = true,
  breadcrumbProg,
  breadcrumbs,
  breadcrumbPaths,
  isRegister = false,
  goBack,
}) {
  // const { pathname, search } = useLocation();
  const { search } = useLocation();
  const { returnUrl } = queryString.parse(search);
  const [isLG] = useMediaQuery(`(min-width: ${theme.breakpoints.lg})`);
  const navigate = useNavigate();
  const {
    isOpen: IsOpenConfirm,
    onOpen: onOpenConfirm,
    onClose: onCloseConfirm,
  } = useDisclosure();

  const Breadcrumb = hasBreadcrumb && (
    <BreadcrumbContainer>
      <StyledFlex>
        <ProgressBreadcrumb
          breadcrumbProg={breadcrumbProg}
          breadcrumbs={breadcrumbs}
          breadcrumbPaths={breadcrumbPaths}
        />
      </StyledFlex>
    </BreadcrumbContainer>
  );

  return (
    <Box>
      <Header>
        <CenteredWrapper
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent={{ base: 'space-between', md: 'unset' }}
          paddingY="4px"
          // paddingX={{ base: '24px', md: '32px', lg: '40px' }}
          margin="0 auto"
          position="relative"
          marginRight={{ base: '48px', xl: 'auto' }}
          zIndex={0}
        >
          <Container>
            <LogoLink to={'/'} aria-label="Logo Home">
              <DynivyLogo logoType="logoName" wSize="96px" />
            </LogoLink>

            {isLG && Breadcrumb}
            <Spacer />
            <>
              {!goBack &&
                (isRegister ? (
                  <StyledFlex
                    aria-label="Close and return to dynivy.com"
                    onClick={onOpenConfirm}
                    cursor="pointer"
                  >
                    <CloseIcon />
                  </StyledFlex>
                ) : (
                  <CloseLink
                    aria-label="Close and return to dynivy.com"
                    to={
                      !returnUrl || returnUrl === 'undefined' ? '/' : returnUrl
                    }
                  >
                    <CloseIcon />
                  </CloseLink>
                ))}
              {goBack && (
                <StyledFlex
                  // aria-label="Close and return to dynivy.com"
                  onClick={() => navigate(`/buyertools/account-settings`)}
                  cursor="pointer"
                >
                  <CloseIcon />
                </StyledFlex>
              )}
            </>
          </Container>

          {!isLG && Breadcrumb}
          <ConfirmCloseModal isOpen={IsOpenConfirm} onClose={onCloseConfirm} />
        </CenteredWrapper>
      </Header>
    </Box>
  );
}

WritingFormHeader.propTypes = {
  hasBreadcrumb: PropTypes.bool,
  isRegister: PropTypes.bool,
  breadcrumbs: PropTypes.arrayOf(PropTypes.string),
  breadcrumbPaths: PropTypes.arrayOf(PropTypes.string),
  breadcrumbProg: PropTypes.number,
  goBack: PropTypes.bool,
};

export default WritingFormHeader;
